import axios from 'axios'
import router from '../router'; 
import { Message } from 'element-ui'

const showError = (message) => {
	let text = String(message || '请求失败').replace(/<[^>]+>/g, ' ').replace(/\s+/g, ' ').trim();
	text = text.length > 300 ? `${text.substring(0, 300)}...` : text;
	Message({
		message: text,
		type: 'error',
		duration: 3000,
		customClass: 'element-error-message-zindex'
	})
}

const http = axios.create({
	baseURL: process.env.VUE_APP_BASE_API,
	timeout: 1000 * 3000
})

/**
 * 请求拦截
 */
http.interceptors.request.use(config => {
	let accessToken = sessionStorage.getItem("accessToken");
	if (accessToken) {
		config.headers.accessToken = encodeURIComponent(accessToken);
	}
	return config
}, error => {
	return Promise.reject(error)
})

/**
 * 响应拦截
 */
http.interceptors.response.use(async response => {
	if (response.data.code == 200) {
		return response.data.data;
	} else if (response.data.code == 400) {
		exit();
		return Promise.reject(response.data);
	} else if (response.data.code == 401) {
		console.log("token失效，尝试重新获取")
		let refreshToken = sessionStorage.getItem("refreshToken");
		if (!refreshToken || response.config.url === '/refreshToken') {
			exit();
			return Promise.reject(response.data);
		}
		// 发送请求, 进行刷新token操作, 获取新的token
		try {
			const data = await http({
				method: 'put',
				url: '/refreshToken',
				headers: {
					refreshToken: refreshToken
				}
			});
			if (!data) {
				throw new Error("刷新Token接口未返回数据");
			}
			// 保存token
			sessionStorage.setItem("accessToken", data.accessToken);
			sessionStorage.setItem("refreshToken", data.refreshToken);
			// 重新发送刚才的请求
			return http(response.config)
		} catch (error) {
			exit();
			return Promise.reject(error || response.data);
		}
	} else {
		showError(response.data.message || `请求失败，业务状态码：${response.data.code}`);
		return Promise.reject(response.data)
	}
}, error => {
	const response = error.response;
	if (!response) {
		showError(error.message === 'Network Error' ? '网络连接失败，请检查网络或服务器状态' :
			(error.message || '网络请求失败'));
		return Promise.reject(error);
	}

	const responseMessage = typeof response.data === 'string' ? response.data :
		(response.data && response.data.message);
	switch (response.status) {
		case 400:
			showError(responseMessage || '请求参数错误');
			break
		case 401:
			exit();
			break
		case 405:
			showError(responseMessage || 'HTTP请求方式有误');
			break
		case 404:
			showError(responseMessage || '请求的接口不存在');
			break
		case 500:
			showError(responseMessage || '服务器内部错误，请稍后再试');
			break
		case 501:
			showError(responseMessage || '服务器不支持当前请求所需要的某个功能');
			break
		default:
			showError(responseMessage || `请求失败，HTTP状态码：${response.status}`);
			break
	}

	return Promise.reject(error)
})

const exit = () => {
	router.app.$eventBus.$emit("exit")
}


export default http
